import { DiagnosticoMatriculaDto } from '../dtos';

export class SecaoDiagnosticoMatricula {
  private diagnosticos: DiagnosticoMatriculaDto[] = [];

  constructor(diagnosticos: DiagnosticoMatriculaDto[] = []) {
    this.diagnosticos = diagnosticos;
  }

  public addDiagnostico(diagnostico: DiagnosticoMatriculaDto): void {
    this.diagnosticos?.push(diagnostico);
  }

  public getTotalMatriculas(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.total, 0);
  }

  public getTotalMatriculasFederal(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaFederal, 0);
  }

  public getTotalMatriculasEstadual(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaEstadual, 0);
  }

  public getTotalMatriculasMunicipal(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaMunicipal, 0);
  }

  public getTotalMatriculasPrivadaConvSemFinsLucrativos(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaConveniadaSemFinsLucrativos, 0);
  }

  public getTotalMatriculasPrivadaConvComFinsLucrativos(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaConveniadaComFinsLucrativos, 0);
  }

  public getTotalMatriculasPrivadaNaoConvSemFinsLucrativos(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaNaoConveniadaSemFinsLucrativos, 0);
  }

  public getTotalMatriculasPrivadaNaoConvComFinsLucrativos(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaNaoConveniadaComFinsLucrativos, 0);
  }

  public getTotalMatriculasPrivadaSemDetalhamento(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.dependenciaSemDetalhamento, 0);
  }

  public getTotalMatriculasUrbana(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.urbana, 0);
  }

  public getTotalMatriculasRural(): number {
    return this.diagnosticos.reduce((total, diagnostico) => total + diagnostico?.rural, 0);
  }
}
